/* dfx-offer-unlock.js — the gate behind snippets/pdp-offers.liquid.
 *
 * Locked PDP offers: the cards ship in the HTML but their wrapper carries the
 * `hidden` attribute server-side, so there is no unlock-then-flash. The shopper
 * enters a mobile number (+ OTP when gate_mode is 'otp') and the wrapper is
 * revealed.
 *
 * Unlock state lives in localStorage with an expiry (30 days by default, settable
 * per block; 0 = until the shopper clears site data). A shopper who already
 * OTP-verified elsewhere (quick-login popup, pincode popup) is let through
 * without re-entering anything, unless the block turns that off.
 *
 * OTP service = the same sh-dfx-tools TrustSignal endpoints every other Duroflex
 * call site uses: 6-digit codes, and a wrong code answers HTTP 400 with a JSON
 * body, so every branch reads `success` / `verified` and never the status code.
 */
(function () {
  if (window.__dfx_offer_unlock_booted) return;
  window.__dfx_offer_unlock_booted = true;

  var API = {
    sendOtp: '/apps/leads/sendOtp',
    verifyOtp: '/apps/leads/verifyOtp',
    // Pins the sender / DLT template. Never a merchant-editable brand stamp —
    // feeding one of those here fires the wrong sender or fails brand pinning.
    otpBrand: 'DFX',
    // Revocation handle, not authentication: readable in View Source. What
    // actually protects the service is its server-side quotas.
    otpApiKey: 'TOULiD7aT2gXMtL-RRWaBL2Z-KjaJjRj5zFEeqjoCQQ',
    dfxLeadCapture: '/apps/leads/createLead',
    dfxLeadKey: '37438c7b9d2819932d7783e5f0c4169b0efcf2cdd674f4d1',
    // Apps Script sheet, Salesforce (SFSC) and the sh-dfx-tools lead store are the
    // same three targets the quick-login popup writes to, so a coupon-gate number
    // lands in exactly the places a quick-view number does.
    googleLeadCapture:
      'https://script.google.com/macros/s/AKfycby9jBb2p_yIXTYPavHWwllQJp6QwIm9XwFt8M2xtEryLjQ4wFx-juS6usugup1r7UXK/exec',
    salesforceLeadCapture: 'https://dfxstorelocatorapi.azurewebsites.net/api/SleepQuiz/LeadCreation',
    salesforceLeadKey: 'TGVhZENyZWF0aW9uU2xlZXBxdWl6'
  };

  var LS_KEY = 'dfx_offers_unlocked';
  var PHONE_RE = /^[6-9]\d{9}$/;
  var DEFAULT_REMEMBER_DAYS = 30;

  // Unlock is remembered in localStorage, not sessionStorage: it has to survive a
  // closed tab and come back on the next visit, so it lives until it expires or the
  // shopper clears site data. Stored as {phone, at, exp}; exp 0 means never expire.
  function readUnlock() {
    var raw;
    try {
      raw = localStorage.getItem(LS_KEY);
    } catch (e) {
      return null;
    }
    if (!raw) {
      // Anyone unlocked under the original sessionStorage build keeps their unlock
      // for the rest of that visit instead of being re-gated mid-session.
      try {
        var legacy = sessionStorage.getItem(LS_KEY);
        return legacy ? { phone: legacy } : null;
      } catch (e) {
        return null;
      }
    }
    var o;
    try {
      o = JSON.parse(raw);
    } catch (e) {
      // Pre-JSON format: the bare phone number.
      return PHONE_RE.test(raw) ? { phone: raw } : null;
    }
    if (!o || !o.phone) return null;
    if (o.exp && Date.now() > o.exp) {
      try {
        localStorage.removeItem(LS_KEY);
      } catch (e) {}
      return null;
    }
    return o;
  }

  function writeUnlock(phone, days) {
    if (!phone) return;
    var now = Date.now();
    try {
      localStorage.setItem(
        LS_KEY,
        JSON.stringify({ phone: phone, at: now, exp: days > 0 ? now + days * 86400000 : 0 })
      );
    } catch (e) {}
  }

  function D() {
    return window.DuroflexPopup || null;
  }

  // Theme marker. Set by snippets/dfx-theme-tracking.liquid from
  // settings.dfx_event_suffix - `_coupon` on this theme, blank on live - so every
  // event this file fires is attributable to the theme that produced it without a
  // second GA4 property.
  function sfx() {
    if (typeof window.DFX_EVENT_SUFFIX === 'string') return window.DFX_EVENT_SUFFIX;
    // Fallback for a page where the layout snippet did not run: the snippet
    // stamps the same value on the offers root.
    var r = document.querySelector('[data-dfx-offer-unlock]');
    return (r && r.dataset.eventSuffix) || '';
  }

  function track(name, data) {
    var evt = name + sfx();
    var d = D();
    if (d && d.track) {
      try {
        d.track(evt, data || {});
        return;
      } catch (e) {}
    }
    // DuroflexPopup is the normal transport, but the offers block can render on a
    // page where the popup bundle never loaded. Fall through to the raw data layer
    // rather than silently dropping the whole coupon funnel.
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: evt, event_source: 'dfx_offer_unlock', event_ts: Date.now() };
      if (data) {
        for (var k in data) {
          if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
        }
      }
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  // MoEngage profile + event, keyed on the phone (customer_id IS the phone).
  // Silent no-op when the bridge has not loaded - never blocks the unlock.
  function moeFire(action, phone, extra) {
    if (!window.DFXMoEngage || !phone) return;
    try {
      var d = D();
      var fields = {
        phone: phone,
        pincode: (d && d.getPincode && d.getPincode()) || '',
        name: '',
        email: ''
      };
      var attrs = DFXMoEngage.leadEventAttrs(fields) || {};
      attrs.theme_label = window.DFX_THEME_LABEL || '';
      attrs.source = 'pdp_offer_unlock';
      if (extra) {
        for (var k in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, k)) attrs[k] = extra[k];
        }
      }
      DFXMoEngage.emit(phone, DFXMoEngage.leadProfile(fields), action + sfx(), attrs);
    } catch (e) {}
  }

  // ---- leads -----------------------------------------------------------------
  // Three targets, the same split the quick-login popup uses:
  //   google_sheet  every stage
  //   dfx_lead      every stage (sh-dfx-tools createLead / Firebase)
  //   salesforce    post_otp only - SFSC must not receive unverified numbers
  // `stage` is the enum the services accept: 'pre_otp' | 'post_otp'.

  // Judge.me stamps data-product-title on its own review widget, and that widget
  // sits earlier in the DOM than the real heading - reading the first match blind
  // put ~1.2KB of review text into the lead's product field (and, now that SFSC is
  // wired, into the CRM). So: skip anything inside a reviews widget, and fall back
  // to structured data before ever trusting a stray data attribute.
  function productTitle() {
    var sels = ['.product__title', 'h1.product__title', '[data-product-title]'];
    for (var i = 0; i < sels.length; i++) {
      var nodes = document.querySelectorAll(sels[i]);
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.closest && n.closest('[class*="jdgm"], .spr-container, .yotpo')) continue;
        var t = ((n.textContent || '').replace(/\s+/g, ' ')).trim();
        if (t && t.length <= 200) return t;
      }
    }
    // Product JSON-LD is what every other consumer of this page reads, so it is the
    // safest fallback when the theme markup has moved.
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var k = 0; k < scripts.length; k++) {
      try {
        var parsed = JSON.parse(scripts[k].textContent);
        var list = Array.isArray(parsed) ? parsed : [parsed];
        for (var m = 0; m < list.length; m++) {
          if (list[m] && list[m]['@type'] === 'Product' && list[m].name) {
            return String(list[m].name).replace(/\s+/g, ' ').trim();
          }
        }
      } catch (e) {}
    }
    var og = document.querySelector('meta[property="og:title"]');
    return ((og && og.content) || '').replace(/\s+/g, ' ').trim();
  }

  // createLead rejects unknown keys with a 400, so this builds its own strict
  // payload rather than reusing the flat legacy blob below.
  function buildDfxLead(phone, stage) {
    var d = D();
    var attr = (d && d.getAttribution && d.getAttribution()) || {};
    var pincode = (d && d.getPincode && d.getPincode()) || '';
    var pinData = (d && d.getPincodeData && d.getPincodeData()) || {};
    var isProduct = location.pathname.indexOf('/products/') !== -1;
    var title = productTitle();
    var now = new Date().toISOString();

    var payload = {
      phone: phone,
      brand: 'DFX',
      lead_status: stage === 'post_otp' ? 'otp_verified' : 'unverified',
      event_timestamp: now,
      attribution: {
        source: 'pdp_offer_unlock',
        event: 'offer_unlock',
        // Enum, not free text: the service only accepts pre_otp / post_otp /
        // details_submitted and 400s the whole lead on anything else. The theme
        // marker rides in page_url and the utm fields, never here.
        lead_stage: stage,
        page_type: isProduct ? 'product' : location.pathname === '/' ? 'index' : 'page',
        page_url: location.href,
        referrer: /^https?:\/\//.test(document.referrer || '') ? document.referrer : null,
        utm_source: attr.utm_source || null,
        utm_medium: attr.utm_medium || null,
        utm_campaign: attr.utm_campaign || null,
        gclid: attr.gclid || null
      },
      // A passive notice under the form, not a tick-box - recorded as what it is.
      consent: {
        marketing: true,
        channels: ['sms', 'whatsapp'],
        granted_at: now,
        method: 'notice',
        ui_surface: 'pdp_offer_unlock',
        locale: 'en-IN'
      }
    };
    // The service wants exactly 6 digits; anything else 400s the whole lead
    // rather than just dropping the field.
    if (/^\d{6}$/.test(pincode)) payload.pincode = pincode;
    if (pinData.city) payload.city = pinData.city;
    if (title) {
      payload.products = [{ name: title.slice(0, 256) }];
      if (isProduct) payload.products[0].url = location.pathname;
    }
    return payload;
  }

  // The flat dual-case blob. Lower-case keys are what the Apps Script sheet reads,
  // Capitalised ones are what Salesforce reads - both services get the same body,
  // exactly as the quick-login popup sends it, so a coupon-gate number lands in the
  // same sheet columns and the same SFSC fields as a quick-view number.
  function buildFlatLead(phone, stage) {
    var d = D();
    var attr = (d && d.getAttribution && d.getAttribution()) || {};
    var pinData = (d && d.getPincodeData && d.getPincodeData()) || {};
    var pincode = (d && d.getPincode && d.getPincode()) || '';
    var title = productTitle();
    var productUrl = location.href.indexOf('/products/') !== -1 ? location.href : '';
    var now = new Date().toISOString();
    var verified = stage === 'post_otp';

    return {
      name: 'DFX_User',
      phone: phone,
      email: '',
      pincode: pincode,
      city: pinData.city || '',
      channel: 'Website',
      // Exact string agreed with the Salesforce team for Opportunity Source
      // "Unlock Offer PDP" - the name is not case sensitive downstream, but
      // keep it as given so nothing else has to normalise it.
      event: 'Unlock_Offer_PDP',
      brand: 'Duroflex',
      product_name: title.slice(0, 160),
      recommendation1: productUrl,
      recommendation2: '',
      recommendation3: '',
      recommendation4: '',
      timestamp: now,
      Page_referrer: location.href,
      Questions_answer_array: '',
      Products_recommendation_array: productUrl,
      User_Agent: navigator.userAgent,
      Employee_Code: '',
      Tag: 'new_lead',
      lead_stage: stage,
      lead_id: [d && d.getSessionId ? d.getSessionId() : '', phone, pincode].join('|'),
      otp_status: verified ? 'verified' : 'pending',

      Event: 'Unlock_Offer_PDP',
      Name: 'DFX_User',
      Phone: phone,
      Email: null,
      Pincode: pincode || null,
      City: pinData.city || null,
      Channel: null,
      Brand: 'Duroflex',
      Store_Name: pinData.storename || null,
      Preferred_Date: null,
      Time_Slot: null,
      Recommendation1: null,
      Recommendation2: null,
      Recommendation3: null,
      Recommendation4: null,
      Products_Recommendation_Array: null,
      Questions_Answer_Array: null,
      Timestamp: now,
      Page_Referrer: location.origin + location.pathname,
      UTM_AirBoost: attr.utm_campaign || null,
      UTM_Source_AirBoost: attr.utm_source || null,
      UTM_Medium: attr.utm_medium || null,
      GCL_ID: attr.gclid || null
    };
  }

  // Keyed phone|pincode|stage, so a shopper who unlocks, reloads and is restored
  // from localStorage does not re-post the same lead.
  var leadDone = {};
  var leadInFlight = {};

  function parseLeadResponse(target, r) {
    return r.text().then(function (text) {
      var parsed = {};
      try {
        parsed = text ? JSON.parse(text) : {};
      } catch (e) {
        parsed = { raw: text };
      }
      if (!r.ok) throw new Error(target + ' HTTP ' + r.status + ': ' + text);
      if (parsed.status && parsed.status !== 'success') {
        throw new Error(target + ' status ' + parsed.status);
      }
      return parsed;
    });
  }

  function postLeadTarget(target, url, headers, body, stage) {
    if (!url) return Promise.resolve(null);
    return fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body),
      keepalive: true
    })
      .then(function (r) {
        return parseLeadResponse(target, r);
      })
      .then(function (data) {
        var oid = (data && (data.opportunityId || data.opportunity_id || data.sfsc)) || null;
        track('offer_lead_submitted_' + target, {
          stage: stage,
          target: target,
          opportunity_id: oid
        });
        return data;
      })
      .catch(function (err) {
        track('offer_lead_failed_' + target, { stage: stage, target: target, error: String(err) });
        throw err;
      });
  }

  // The single entry point: everything on this surface that captures a number
  // calls this and nothing else.
  function submitLead(phone, stage) {
    if (!phone) {
      track('offer_lead_skipped_no_phone', { stage: stage });
      return;
    }
    var d = D();
    var pincode = (d && d.getPincode && d.getPincode()) || '';
    var key = phone + '|' + pincode + '|' + stage;
    if (leadDone[key] || leadInFlight[key]) {
      track('offer_lead_skipped_duplicate', { stage: stage });
      return;
    }
    leadInFlight[key] = true;
    track('offer_lead_attempt', { stage: stage });

    var flat = buildFlatLead(phone, stage);
    var strict = buildDfxLead(phone, stage);
    var posts = [
      postLeadTarget(
        'google_sheet',
        API.googleLeadCapture,
        { 'Content-Type': 'text/plain' },
        flat,
        stage
      ),
      postLeadTarget(
        'dfx_lead',
        API.dfxLeadCapture,
        { 'Content-Type': 'application/json', 'X-API-Key': API.dfxLeadKey },
        strict,
        stage
      )
    ];
    var targets = 'google_sheet,dfx_lead';

    // Salesforce takes verified numbers only - the same rule the quick-login popup
    // applies. A phone-only gate therefore never reaches SFSC, by design.
    if (stage === 'post_otp') {
      posts.push(
        postLeadTarget(
          'salesforce',
          API.salesforceLeadCapture,
          { 'Content-Type': 'application/json', 'X-Api-Key': API.salesforceLeadKey },
          flat,
          stage
        )
      );
      targets += ',salesforce';
    }

    Promise.allSettled(posts)
      .then(function (results) {
        var failed = results.filter(function (r) {
          return r.status === 'rejected';
        }).length;
        if (failed) {
          track('offer_lead_partial', { stage: stage, targets: targets, failed: failed });
          return;
        }
        leadDone[key] = true;
        track('offer_lead_submitted', { stage: stage, targets: targets });
      })
      .finally(function () {
        leadInFlight[key] = false;
      });

    moeFire(
      stage === 'post_otp' ? 'PDP Offers - Phone Verified' : 'PDP Offers - Phone Submitted',
      phone,
      { lead_stage: stage, product_name: flat.product_name, page_url: location.href }
    );
  }

  // ---- experiment + measurement ---------------------------------------------
  // The arm is assigned by the inline script inside the snippet (so `control`
  // never sees a flash of the locked state) and only READ here. It is persisted
  // without an expiry: a visitor must stay in the same arm for the whole test,
  // otherwise the comparison is meaningless.
  var EXP_KEY = 'dfx_offer_experiment';

  function readVariant() {
    try {
      var o = JSON.parse(localStorage.getItem(EXP_KEY) || 'null');
      if (o && (o.v === 'gated' || o.v === 'control')) return o.v;
    } catch (e) {}
    return null;
  }

  // Every push carries the same dimensions so GA4 can split any step of the
  // funnel by arm and by theme without a second lookup.
  function context(root) {
    return {
      experience: root.dataset.experience || readVariant() || 'gated',
      theme_id: root.dataset.themeId || '',
      theme_name: root.dataset.themeName || '',
      gate_mode: root.dataset.gateMode || 'off',
      theme_label: root.dataset.themeLabel || window.DFX_THEME_LABEL || '',
      unlock_state: root.classList.contains('dfx-ou--unlocked') ? 'unlocked' : 'locked'
    };
  }

  function trackIn(root, name, data) {
    var payload = context(root);
    if (data) {
      for (var k in data) {
        if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
      }
    }
    track(name, payload);
  }

  // Stamped on the cart so the arm reaches the Shopify order — GA4 events alone
  // cannot tell you which arm actually produced revenue. Fired after an
  // add-to-cart click, and only once a line item really exists, so we never
  // create an empty cart for a shopper who did not add anything.
  function stampCartAttribute(root) {
    if (root.__dfxCartStamped) return;
    root.__dfxCartStamped = true;
    var ctx = context(root);
    setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.item_count) {
            root.__dfxCartStamped = false; // let a later, successful add try again
            return;
          }
          if (cart.attributes && cart.attributes.offer_gate_variant === ctx.experience) return;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                offer_gate_variant: ctx.experience,
                offer_gate_state: ctx.unlock_state
              }
            })
          });
        })
        .catch(function () {
          root.__dfxCartStamped = false;
        });
    }, 1200);
  }

  // The heading's View All opens the same GoKwik drawer the unlock auto-opens.
  // If GoKwik has no offers for this variant there is nothing to open, so the button
  // retires itself rather than sitting there as a dead CTA.
  function bindViewAll(root) {
    var btn = root.querySelector('[data-dfx-viewall]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      trackIn(root, 'offer_view_all_click', {});
      trackIn(root, 'explore_coupons', { trigger: 'view_all' });
      openGokwikOffers(root);
      watchGokwikClose(root);
    });

    // The button's visibility is decided by this poll, not by a one-shot check:
    // GoKwik's tiles render well after DOMContentLoaded, so an immediate lookup at
    // unlock time finds nothing. Reveal only when unlocked AND a target exists;
    // give up (stay hidden) if GoKwik has no offers for this variant.
    var timer = null;
    function sync() {
      if (timer) clearTimeout(timer);
      var deadline = Date.now() + 10000;
      (function poll() {
        if (!root.classList.contains('dfx-ou--locked') && findGokwikViewAll(root)) {
          btn.hidden = false;
          return;
        }
        if (Date.now() < deadline) {
          timer = setTimeout(poll, 500);
          return;
        }
        btn.hidden = true;
      })();
    }
    // Re-run whenever the shopper unlocks, since that is usually long after load.
    root.__dfxViewAllSync = sync;
    sync();
  }

  function bindMeasurement(root) {
    // One assignment ping per page so GTM can map `experience` onto a GA4 user
    // property; without it only the arm's own events would be attributable.
    trackIn(root, 'offer_experiment_assigned', {});

    // Impression, not render: the funnel denominator has to be "saw the gate".
    var gate = root.querySelector('[data-dfx-gate]');
    if (gate && !gate.hidden && 'IntersectionObserver' in window) {
      var seen = false;
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!seen && entries[i].isIntersecting) {
              seen = true;
              trackIn(root, 'offer_gate_view', {});
              io.disconnect();
            }
          }
        },
        { threshold: 0.25 }
      );
      io.observe(gate);
    }

    // "Explore coupons": the first real engagement with the offer carousel on this
    // page - a card tap or a swipe along the row. Fired once, so it reads as a
    // step in the funnel (saw gate -> explored coupons -> unlocked -> added to
    // cart) rather than as an engagement counter.
    var explored = false;
    function markExplored(how) {
      if (explored) return;
      explored = true;
      trackIn(root, 'explore_coupons', { trigger: how });
      var d = D();
      var known = (d && d.getPhone && d.getPhone()) || '';
      if (known) moeFire('PDP Offers - Explored', known, { trigger: how });
    }

    // Card engagement. Delegated, so GoKwik / Snapmint tiles injected later count too.
    var row = root.querySelector('.mainoffers');
    if (row) {
      row.addEventListener(
        'scroll',
        function () {
          if (row.scrollLeft > 8) markExplored('swipe');
        },
        { passive: true }
      );
      row.addEventListener('click', function (e) {
        // Our own openGokwikOffers() calls .click() on the tile's shadow button, and
        // that synthetic event is composed — it bubbles out here and would inflate
        // card engagement with clicks no shopper made. Only trusted events count.
        if (!e.isTrusted) return;
        var card = e.target.closest ? e.target.closest('.offeritem, .gokwik-offer-widget-tile') : null;
        var label = '';
        if (card) {
          var tag = card.querySelector('.offertag');
          label = ((tag && tag.textContent) || card.className || '').trim().slice(0, 60);
        } else {
          label = 'gokwik_tile';
        }
        markExplored('card_click');
        trackIn(root, 'offer_card_click', { card: label });
      });
    }

    // Add-to-cart anywhere on the page stamps the cart attribute.
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target.closest
          ? e.target.closest('button[name="add"], .product-form__submit, .airboost-atc button')
          : null;
        if (t) stampCartAttribute(root);
      },
      true
    );
  }

  // GoKwik renders its drawer inside an existing shadow root — no new iframe, body
  // child or fixed container appears — but it does lock body scroll while open.
  // That flip back to unlocked is the only reliable close signal available.
  function watchGokwikClose(root) {
    var locked = false;
    var stop = Date.now() + 300000;
    var t = setInterval(function () {
      var isLocked = /hidden/.test(getComputedStyle(document.body).overflow);
      if (isLocked) locked = true;
      if (locked && !isLocked) {
        clearInterval(t);
        trackIn(root, 'offer_gokwik_closed', {});
        return;
      }
      if (Date.now() > stop) clearInterval(t);
    }, 500);
  }

  // ---- GoKwik "View all" ----------------------------------------------------
  // Each GoKwik tile is its own OPEN shadow host — `div.gokwik-offer-widget-tile`,
  // not the <gokwik-offer-widget> custom element (that one just bootstraps them).
  // Inside the shadow root the structure is:
  //   div[part=container] > div[part=tile] > h4[part=title] + p[part=subtitle]
  //                                        + button[part=button]   <- "View all"
  // Clicking that button opens GoKwik's vertical offers drawer.
  function gokwikShadowHosts(root) {
    var hosts = [];
    function collect(scope) {
      if (!scope || !scope.querySelectorAll) return;
      var tiles = scope.querySelectorAll('.gokwik-offer-widget-tile, [class*="gokwik-offer-widget-tile"]');
      for (var i = 0; i < tiles.length; i++) hosts.push(tiles[i]);
    }
    collect(root);
    // Tiles may also be nested inside the custom element (light or shadow DOM),
    // depending on which GoKwik build is serving.
    var widgets = root.querySelectorAll('gokwik-offer-widget');
    for (var w = 0; w < widgets.length; w++) {
      collect(widgets[w]);
      collect(widgets[w].shadowRoot);
      if (widgets[w].shadowRoot) hosts.push(widgets[w]);
    }
    return hosts;
  }

  function findGokwikViewAll(root) {
    var hosts = gokwikShadowHosts(root);
    for (var i = 0; i < hosts.length; i++) {
      var scope = hosts[i].shadowRoot || hosts[i];
      if (!scope.querySelector) continue;
      var btn = scope.querySelector('button[part="button"]');
      if (!btn) {
        // Fallback if GoKwik ever drops the part attribute.
        var nodes = scope.querySelectorAll('button, a, [role="button"]');
        for (var j = 0; j < nodes.length; j++) {
          if (/^view\s*all\b/i.test((nodes[j].textContent || '').trim())) {
            btn = nodes[j];
            break;
          }
        }
      }
      // A tile that rendered but has no offers has no box — skip it rather than
      // clicking a zero-size button.
      if (btn && btn.getClientRects().length) return btn;
    }
    return null;
  }

  // Poll for up to ~8s after the reveal: the tiles render async, and they render
  // nothing at all when GoKwik has no offers for the variant. No element found ->
  // nothing opens, which is the required behaviour.
  function openGokwikOffers(root) {
    var deadline = Date.now() + 8000;
    (function attempt() {
      var el = findGokwikViewAll(root);
      if (el) {
        try {
          el.click();
          trackIn(root, 'offer_unlock_gokwik_opened', {});
          watchGokwikClose(root);
        } catch (e) {}
        return;
      }
      if (Date.now() < deadline) setTimeout(attempt, 400);
    })();
  }

  // Which copy of the deal-strip headline shows: the teaser (custom.locked_deal_price)
  // while the gate is locked, the real price (custom.deal_price) otherwise. Derived
  // from the root class so it is correct for gate mode off, the control arm, a
  // silent restore and a fresh unlock alike.
  function syncStripState(root) {
    var locked = root.classList.contains('dfx-ou--locked');
    var teaser = root.querySelector('[data-dfx-strip-locked]');
    var real = root.querySelector('[data-dfx-strip-unlocked]');
    if (teaser) teaser.hidden = !locked;
    if (real) real.hidden = locked;
    // A variant with no custom.deal_price (Custom sizes) still gets the box rendered
    // because locked_deal_price exists; live prints nothing for it, so hide the box
    // whenever the copy that should show is empty.
    var strip = root.querySelector('.dfx-ou__strip');
    if (strip) {
      var shown = locked ? teaser : real;
      strip.style.display = shown && shown.textContent.trim() ? '' : 'none';
    }
  }

  // The dfx-pdp component is the strip's only writer (S5 on a size pick, R4 on
  // variantChange, D13), so it has to re-apply the locked/unlocked visibility rule
  // after each write. It lives in another script and cannot reach this closure;
  // exposing the function keeps that rule in one place instead of copying it.
  window.DfxOfferUnlock = window.DfxOfferUnlock || {};
  window.DfxOfferUnlock.syncStripState = syncStripState;

  function init(root) {
    if (root.__dfxOuBooted) return;
    root.__dfxOuBooted = true;

    var mode = root.dataset.gateMode || 'off';
    var vault = root.querySelector('[data-dfx-vault]');
    var gate = root.querySelector('[data-dfx-gate]');

    bindDragScroll(root);
    if (mode === 'phone' || mode === 'otp') bindMeasurement(root); // no experiment pings while the gate is off (2 Oct)
    bindViewAll(root);

    // Control arm: the snippet's inline script already un-hid the vault via CSS so
    // there is no flash; clear the attribute too so assistive tech agrees with the
    // pixels, then skip the gate entirely.
    if (root.dataset.experience === 'control') {
      if (vault) vault.hidden = false;
      if (gate) gate.hidden = true;
      root.classList.remove('dfx-ou--locked');
      syncStripState(root);
      return;
    }

    syncStripState(root);
    if (mode !== 'phone' && mode !== 'otp') return;
    if (!vault || !gate) return;

    var phoneInput = gate.querySelector('[data-dfx-phone]');
    var otpField = gate.querySelector('[data-dfx-otp-field]');
    var otpInput = gate.querySelector('[data-dfx-otp]');
    var submitBtn = gate.querySelector('[data-dfx-submit]');
    var btnLabel = gate.querySelector('[data-dfx-btn-label]');
    var resendBtn = gate.querySelector('[data-dfx-resend]');
    var statusEl = gate.querySelector('[data-dfx-status]');

    var otpSent = false;
    var resendSeconds = 60;
    var resendTimer = null;
    var rememberDays = parseInt(root.dataset.rememberDays, 10);
    if (isNaN(rememberDays) || rememberDays < 0) rememberDays = DEFAULT_REMEMBER_DAYS;

    function setStatus(msg, kind) {
      if (!statusEl) return;
      statusEl.textContent = msg || '';
      statusEl.className =
        'dfx-ou__status' + (msg && kind ? ' dfx-ou__status--' + kind : '');
    }

    function unlock(phone, verified, silent) {
      if (phone) writeUnlock(phone, rememberDays);
      vault.hidden = false;
      gate.hidden = true;
      // View All appears only now: offering it while locked would let a shopper
      // open GoKwik's drawer without ever giving a phone number. The class is
      // dropped just below, so defer the sync until after that.
      if (root.__dfxViewAllSync) setTimeout(root.__dfxViewAllSync, 0);
      root.classList.remove('dfx-ou--locked');
      root.classList.add('dfx-ou--unlocked');
      // Swap the teaser headline for the real one (custom.locked_deal_price ->
      // custom.deal_price). Both were rendered server-side.
      syncStripState(root);
      // Snapmint / GoKwik tiles laid out inside a hidden container measure zero.
      // Nudge them once the row actually has a box.
      try {
        window.dispatchEvent(new Event('resize'));
      } catch (e) {}
      try {
        root.dispatchEvent(
          new CustomEvent('duroflex:offers-unlocked', {
            bubbles: true,
            detail: { phone: phone || '', verified: !!verified }
          })
        );
      } catch (e) {}
      // Runs even on a silent unlock (session restore / reuse-verified-phone) so
      // SFSC always gets the lead. submitLead() dedupes on phone|pincode|stage,
      // so a repeat silent unlock for the same shopper is a no-op, not a resend.
      if (phone) submitLead(phone, verified ? 'post_otp' : 'pre_otp');
      if (!silent) {
        trackIn(root, 'offer_unlock', { phone: phone || '', verified: !!verified });
        moeFire('PDP Offers - Unlocked', phone, {
          verified: !!verified,
          gate_mode: root.dataset.gateMode || 'off'
        });
        // Only on a real unlock the shopper just performed — never on the silent
        // session/verified-phone restore, which would pop the drawer on every page.
        openGokwikOffers(root);
      }
    }

    // Already unlocked (this visit or a previous one inside the window)? Or already
    // OTP-verified on another surface?
    var stored = readUnlock();
    if (stored && stored.phone) {
      unlock(stored.phone, true, true);
      return;
    }
    if (root.dataset.reuseVerified === '1') {
      var d = D();
      if (d && d.isOtpVerified && d.isOtpVerified()) {
        var known = (d.getVerifiedPhone && d.getVerifiedPhone()) || (d.getPhone && d.getPhone()) || '';
        if (known) {
          unlock(known, true, true);
          return;
        }
      }
      // Prefill a known-but-unverified number so the shopper only taps Unlock.
      if (d && d.getPhone && phoneInput) {
        var seen = d.getPhone();
        if (PHONE_RE.test(seen)) phoneInput.value = seen;
      }
    }

    function startResendCooldown(seconds) {
      if (!resendBtn) return;
      var left = seconds;
      resendBtn.disabled = true;
      resendBtn.textContent = 'Resend OTP in ' + left + 's';
      if (resendTimer) clearInterval(resendTimer);
      resendTimer = setInterval(function () {
        left -= 1;
        if (left <= 0) {
          clearInterval(resendTimer);
          resendTimer = null;
          resendBtn.disabled = false;
          resendBtn.textContent = 'Resend OTP';
          return;
        }
        resendBtn.textContent = 'Resend OTP in ' + left + 's';
      }, 1000);
    }

    function sendOtp(phone) {
      submitBtn.disabled = true;
      return fetch(API.sendOtp, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-API-Key': API.otpApiKey },
        body: JSON.stringify({ phone: phone, brand: API.otpBrand })
      })
        .then(function (r) {
          return r.text().then(function (t) {
            try {
              return JSON.parse(t);
            } catch (e) {
              return { success: r.ok };
            }
          });
        })
        .then(function (data) {
          if (!data || data.success !== true) {
            setStatus((data && data.message) || 'Could not send OTP', 'err');
            trackIn(root, 'offer_unlock_otp_send_fail', { phone: phone });
            return false;
          }
          // The service enforces its own per-number window; drive the cooldown
          // off what it reports rather than a guess that it would reject.
          if (typeof data.resendAfterSeconds === 'number') resendSeconds = data.resendAfterSeconds;
          otpSent = true;
          if (otpField) otpField.hidden = false;
          if (otpInput) {
            otpInput.disabled = false;
            otpInput.focus();
          }
          if (btnLabel) btnLabel.textContent = submitBtn.dataset.labelVerify || 'Verify';
          setStatus('OTP sent to ' + phone, 'ok');
          startResendCooldown(resendSeconds);
          trackIn(root, 'offer_unlock_otp_sent', { phone: phone });
          // Capture the number the moment it is given, before the code is keyed
          // in. A shopper who never finishes the OTP is still a lead - dropping
          // them was the single biggest hole in this flow versus quick-login.
          submitLead(phone, 'pre_otp');
          return true;
        })
        .catch(function () {
          setStatus('Network error, try again', 'err');
          return false;
        })
        .finally(function () {
          submitBtn.disabled = false;
        });
    }

    function verifyOtp(phone, otp) {
      submitBtn.disabled = true;
      return fetch(API.verifyOtp, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-API-Key': API.otpApiKey },
        body: JSON.stringify({ phone: phone, otp: otp, brand: API.otpBrand })
      })
        // A wrong code is HTTP 400 with a JSON body, so read the text and branch
        // on `verified` — this also survives an HTML error page from infra.
        .then(function (r) {
          return r.text().then(function (t) {
            try {
              return JSON.parse(t);
            } catch (e) {
              return { verified: false, message: 'Could not verify OTP' };
            }
          });
        })
        .then(function (data) {
          if (!data || data.verified !== true) {
            setStatus((data && data.message) || 'Incorrect OTP, try again', 'err');
            trackIn(root, 'offer_unlock_otp_fail', { phone: phone });
            return false;
          }
          var d = D();
          if (d && d.setPhone) d.setPhone(phone, { otpVerified: true });
          if (resendTimer) {
            clearInterval(resendTimer);
            resendTimer = null;
          }
          setStatus('');
          unlock(phone, true);
          return true;
        })
        .catch(function () {
          setStatus('Network error, try again', 'err');
          return false;
        })
        .finally(function () {
          submitBtn.disabled = false;
        });
    }

    submitBtn.addEventListener('click', function () {
      if (submitBtn.disabled) return;
      var phone = String((phoneInput && phoneInput.value) || '').trim();
      if (!PHONE_RE.test(phone)) {
        setStatus('Enter a valid 10-digit mobile number', 'err');
        if (phoneInput) phoneInput.focus();
        return;
      }

      trackIn(root, 'offer_gate_phone_submit', { phone: phone, mode: mode });

      if (mode === 'phone') {
        var d = D();
        if (d && d.setPhone) d.setPhone(phone);
        setStatus('');
        unlock(phone, false);
        return;
      }

      if (!otpSent) {
        setStatus('');
        sendOtp(phone);
        return;
      }
      var otp = String((otpInput && otpInput.value) || '').trim();
      // Exactly 6 — the service issues 6-digit codes and allows only 5 attempts
      // per number, so a partial entry would spend a real attempt.
      if (!/^\d{6}$/.test(otp)) {
        setStatus('Enter the 6-digit OTP sent to your phone', 'err');
        return;
      }
      verifyOtp(phone, otp);
    });

    if (resendBtn) {
      resendBtn.addEventListener('click', function () {
        if (resendBtn.disabled) return;
        var phone = String((phoneInput && phoneInput.value) || '').trim();
        if (!PHONE_RE.test(phone)) {
          setStatus('Enter a valid 10-digit mobile number', 'err');
          return;
        }
        sendOtp(phone);
      });
    }

    // Editing the number after the code was sent puts the flow back to step 1,
    // otherwise the shopper would be verifying a code against the wrong number.
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(0, 10);
        if (otpSent) {
          otpSent = false;
          if (otpField) otpField.hidden = true;
          if (otpInput) otpInput.value = '';
          if (btnLabel) btnLabel.textContent = submitBtn.dataset.labelUnlock || 'Unlock';
          if (resendTimer) {
            clearInterval(resendTimer);
            resendTimer = null;
          }
          setStatus('');
        }
      });
      phoneInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitBtn.click();
        }
      });
    }

    if (otpInput) {
      otpInput.addEventListener('input', function () {
        otpInput.value = otpInput.value.replace(/\D/g, '').slice(0, 6);
      });
      otpInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitBtn.click();
        }
      });
    }
  }

  // Drag-to-scroll on the offers row. Scoped to this instance — the old inline
  // version grabbed document.querySelector('.mainoffers'), so a second offers
  // block on the page got no drag and a page without one threw.
  function bindDragScroll(root) {
    var slider = root.querySelector('.mainoffers');
    if (!slider || slider.__dfxDragBound) return;
    slider.__dfxDragBound = true;

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    slider.addEventListener('mousedown', function (e) {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', function () {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', function () {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - (x - startX) * 3;
    });
  }

  function boot() {
    document.querySelectorAll('[data-dfx-offer-unlock]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Section re-render in the theme editor, and variant swaps that replace the
  // product info column, both drop a fresh copy of the markup in.
  document.addEventListener('shopify:section:load', boot);
})();
